import {
  router,
  subRouter,
  navigation,
  browser,
  ui,
  console,
  storage,
  device,
  clip,
  media,
  connection,
  locationDSL,
  pay,
  link,
  net,
  proxy,
  token,
  alipay,
  file,
  envVar,
  i18n,
  region,
  message,
  envFn,
  env,
  voice,
  plan,
  ecr,
  converter,
  logger,
  cache,
  migrate,
  permission,
  _money,
  CalculationUtils,
  registerNativeAPI,
  spa,
  iot,
  store,
  performance,
  webMaxAPI
} from '@platform/index'
import { FloatMath } from '../api/math/FloatMath'
import { _default } from './ctx'

let inited = false

export function registerRouter() {
  // router
  _default.register('router.redirectTo', router.redirectTo)
  _default.register('router.navigateTo', router.navigateTo)
  _default.register('router.navigateBack', router.navigateBack)
  _default.register('router.navigateBackTo', router.navigateBackTo)
  _default.register('router.getAllStack', router.getAllStack)
  _default.register('router.getTopRoute', router.getCurrent)
  _default.register('router.clearAllStack', router.clearAllStack)
  _default.register('router.reload', router.reload)

  // subRouter
  _default.register('subRouter.redirectTo', subRouter.redirectTo)
  _default.register('subRouter.navigateTo', subRouter.navigateTo)
  _default.register('subRouter.navigateBack', subRouter.navigateBack)
  _default.register('subRouter.navigateBackTo', subRouter.navigateBackTo)
  _default.register('subRouter.getAllStack', subRouter.getAllStack)
  _default.register('subRouter.getTopRoute', subRouter.getCurrent)
  _default.register('subRouter.clearAllStack', subRouter.clearAllStack)

  // web open
  _default.register('router.open', browser.open)
  _default.register('browser.open', browser.open)

  // naviagtion
  _default.register('router.getParams', navigation.getParams)
  _default.register('router.getCurrent', navigation.getCurrent)
  _default.register('router.isSubScreen', navigation.isSubScreen)
  _default.register('navigation.getParams', navigation.getParams)
  _default.register('navigation.getCurrent', navigation.getCurrent)
  _default.register('navigation.isSubScreen', navigation.isSubScreen)
  _default.register('setNavigationBarTitle', navigation.setNavigationBarTitle)
}

export function registerBase() {
  // permission
  _default.register('permission.isGranted', permission.isGranted)
  _default.register('permission.request', permission.request)

  // money
  _default.register('lib.money.of', _money.of)
  _default.register('lib.money.ofMajor', _money.ofMajor)
  _default.register('lib.money.min', _money.min)
  _default.register('lib.money.max', _money.max)
  _default.register('lib.money.isMoney', _money.isMoney)
  _default.register('lib.money.equals', _money.equals)
  _default.register('lib.money.compare', _money.compare)
  _default.register('lib.money.getContext', _money.getContext)
  _default.register('lib.money.setContext', _money.setContext)
  _default.register('lib.money.format', _money.format)
  _default.register('lib.money.toMajor', _money.toMajor)
  _default.register('lib.money.symbol', _money.symbol)
  _default.register('lib.money.currency', _money.currency)
  _default.register('lib.money.locale', _money.locale)
  _default.register('lib.money.add', _money.add)
  _default.register('lib.money.subtract', _money.subtract)
  _default.register('lib.money.multiply', _money.multiply)
  _default.register('lib.money.divide', _money.divide)
  _default.register('lib.money.avg', _money.avg)
  _default.register('lib.money.formatParts', _money.formatParts)
  _default.register('lib.money.around', _money.around)


  // 兼容
  _default.register('router.restart', device.restart)
  _default.register('router.hasSubScreen', device.hasSubScreen)
  _default.register('router.exit', device.exit)

  // ui
  _default.register('ui.dialog', ui.showDlg)
  _default.register('ui.picker', ui.showPicker)
  _default.register('ui.drawer', ui.showDrawer)
  _default.register('ui.subscreen', ui.showSubscreen)
  _default.register('ui.toast', ui.toast)
  _default.register('ui.fullScreen', ui.fullScreen)
  _default.register('ui.fullScreenByApp', ui.fullScreenByApp)
  _default.register('ui.intercept', ui.intercept)
  _default.register('ui.loading', ui.loading)
  // 新增：全局浮层
  _default.register('ui.showOverlay', ui.showOverlay)
  _default.register('ui.hideOverlay', ui.hideOverlay)


  // console
  _default.register('console.log', console.log)
  _default.register('console.debug', console.debug)
  _default.register('console.warn', console.warn)
  _default.register('console.error', console.error)
  _default.register('console.info', console.info)

  // net
  _default.register('net.init', net.config)
  _default.register('net.get', net.get)
  _default.register('net.request', net.request)
  _default.register('net.post', net.post)
  _default.register('net.upload', net.upload)
  _default.register('net.down', net.download)
  _default.register('net.download', net.download)
  _default.register('net.delete', net.delete)
  _default.register('net.put', net.put)
  _default.register('serviceCall', net.serviceCall)
  _default.register('net.getNetStatus', connection.getNetStatus)
  _default.register('net.listener', net.listener)
  _default.register('net.removeListener', net.removeListener)
  _default.register('net.enableCache', net.enableCache)
  _default.register('net.clearCache', net.clearCache)

  // device
  _default.register("device.info", device.info)
  _default.register("device.printHTML", device.printHTML)
  _default.register('device.hasSubScreen', device.hasSubScreen)
  _default.register('device.scan', device.scan)
  _default.register('device.networkPrinter', device.networkPrinter)
  _default.register('device.scanWithData', device.scanWithData)
  _default.register('device.removeScanWithData', device.removeScanWithData)
  _default.register('device.getSerialNumber', device.getSerialNumber)
  _default.register('device.print', device.print)
  _default.register('device.md5', device.md5)
  _default.register('device.sha256', device.sha256)
  _default.register('device.des', device.des)
  _default.register('device.decryptDES', device.decryptDES)
  _default.register('device.desIV', device.desIV)
  _default.register('device.decryptDESIV', device.decryptDESIV)
  _default.register('device.getService', device.getService)
  _default.register('device.setProperty', device.setProperty)
  _default.register('device.getDevice', device.getDevice)
  _default.register('device.backListener', device.backListener)
  _default.register('device.removeBackListener', device.removeBackListener)
  _default.register('device.registerServiceProperty', device.registerServiceProperty)
  _default.register('device.bindExt', device.bindExt)
  _default.register('device.getProperty', device.getProperty)
  _default.register('device.unregisterServiceProperty', device.unregisterServiceProperty)
  _default.register('device.registerServiceChange', device.registerServiceChange)
  _default.register('device.unregisterServiceChange', device.unregisterServiceChange)
  _default.register('device.launchHandler', device.launchHandler)
  _default.register('device.keyboardRegister', device.keyboardRegister)
  _default.register('device.keyboardUnregister', device.keyboardUnregister)
  _default.register('device.registerServiceEvent', device.registerServiceEvent)
  _default.register('device.unregisterServiceEvent', device.unregisterServiceEvent)
  _default.register('device.adapterListener', device.adapterListener)
  _default.register('device.searchBTDevice', device.searchBTDevice)
  _default.register('device.cancelSearchBT', device.cancelSearchBT)
  _default.register('device.keepScreenOn', device.keepScreenOn)
  _default.register('device.info', device.info)

  // 执行优先度相对较低的任务
  _default.register('idleCallback', device.idleCallback)

  // storage
  _default.register('localStorage.get', storage.get)
  _default.register('localStorage.set', storage.set)
  _default.register('localStorage.remove', storage.remove)
  _default.register('localStorage.clear', storage.clear)
  _default.register('localStorage.addListener', storage.addListener)
  _default.register('localStorage.removeListener', storage.removeListener)

  // token
  _default.register('getToken', token.get)
  _default.register('setToken', token.set)
  _default.register('addTokenListener', token.addTokenListener)
  _default.register('removeTokenListener', token.removeTokenListener)

  // store
  _default.register('getStore', store.get)
  _default.register('setStore', store.set)

  // env
  _default.register('env.getEnv', envFn.getEnv)
  Object.assign(_default.max.env, env)
  _default.register('region.set', region.set)
  _default.register('region.get', region.get)
  _default.register('envVar.getValue', envVar.getValue)
  _default.register('envVar.getMap', envVar.getMap)

  // clip
  _default.register('clip.get', clip.get)
  _default.register('clip.set', clip.set)
  _default.register('clip.clear', clip.clear)

  // media
  _default.register('media.choose', media.choose)

  // connection
  _default.register('connection.getNetStatus', connection.getNetStatus)
  _default.register('conection.getNetStatus', connection.getNetStatus) // 兼容旧方案

  // location
  _default.register('location.get', locationDSL.get)

  // pay
  _default.register('pay.qrCodePay', pay.qrCodePay)
  _default.register('pay.smilePay', pay.smilePay)
  _default.register('pay.payCode', pay.payCode)

  // alipay
  _default.register('alipay.deviceInfo', alipay.deviceInfo)
  _default.register('alipay.verify', alipay.verify)
  _default.register('alipay.exit', alipay.exit)

  // file
  _default.register('file.read', file.read)
  _default.register('file.create', file.create)
  _default.register('file.append', file.append)
  _default.register('file.exists', file.exists)
  _default.register('file.delete', file.delete)

  // message
  _default.register('message', message.message)

  /** 711演示示例代码 */
  _default.register('link.scanner', (fn: (code: string) => void) => link.addListener('scanner', fn))
  _default.register('link.removeScanner', link.removeLastListener)

  // proxy
  _default.register('proxy.params', proxy.params)

  // i18n
  _default.register('i18n.getLangList', i18n.getLangList)
  _default.register('i18n.getCurrentLang', i18n.getCurrentLang)
  _default.register('i18n.setCurrentLang', i18n.setCurrentLang)
  _default.register('i18n.onChange', i18n.onChange)

  // voice
  _default.register('voice.play', voice.play)
  _default.register('voice.stop', voice.stop)
  _default.register('voice.pause', voice.pause)
  _default.register('voice.isPause', voice.isPause)
  _default.register('voice.resume', voice.resume)
  _default.register('voice.download', voice.download)
  _default.register('voice.queuePlay', voice.queuePlay)

  // converter
  _default.register('converter.qrCode', converter.qrCode)
  _default.register('converter.printPicture', converter.printPicture)
  _default.register('converter.dataToPicture', converter.dataToPicture)
  _default.register('converter.onlinePrint', converter.onlinePrint)
  _default.register('converter.dataToBase64', converter.dataToBase64)
  _default.register('converter.dataToBase64s', converter.dataToBase64s)

  _default.register('plan.reset', plan.reset)

  _default.register('ecr.connect', ecr.connect)
  _default.register('ecr.disconnect', ecr.disconnect)
  _default.register('ecr.register', ecr.register)
  _default.register('ecr.unregister', ecr.unregister)
  _default.register('ecr.send', ecr.send)
  _default.register('ecr.getBlueToothAddress', ecr.getBlueToothAddress)

  // apm日志
  _default.register('logger.log', logger.log)
  _default.register('logger.error', logger.error)

  // cache
  _default.register('cache.get', cache.get)
  _default.register('cache.set', cache.set)
  _default.register('cache.clear', cache.clear)
  _default.register('cache.remove', cache.remove)

  // migrate
  _default.register('migrate.init', migrate.init)
  _default.register('migrate.setStoreInfo', migrate.setStoreInfo)
  _default.register('migrate.setConfig', migrate.setConfig)
  _default.register('migrate.getStoreInfo', migrate.getStoreInfo)
  _default.register('migrate.setPermCodes', migrate.setPermCodes)
  _default.register('migrate.getPermCodes', migrate.getPermCodes)
  _default.register('migrate.setUserInfo', migrate.setUserInfo)
  _default.register('migrate.getUserInfo', migrate.getUserInfo)
  _default.register('migrate.getMode', migrate.getMode)
  _default.register('migrate.syncData', migrate.syncData)
  _default.register('migrate.uploadModelLog', migrate.uploadModelLog)
  _default.register('migrate.setMigrateUIConfig', migrate.setMigrateUIConfig)
  _default.register('migrate.isUploadModelLog', migrate.isUploadModelLog)
  _default.register('migrate.forceRequestRemote', migrate.forceRequestRemote)
  _default.register('migrate.isForceRequestRemote', migrate.isForceRequestRemote)
  _default.register('migrate.getAppInfo', migrate.getAppInfo)

  // math
  _default.register('ext.math.add', FloatMath.add)
  _default.register('ext.math.subtract', FloatMath.subtract)
  _default.register('ext.math.multiply', FloatMath.multiply)
  _default.register('ext.math.divide', FloatMath.divide)
  _default.register('ext.math.toFixed', CalculationUtils.toFixed)

  // spa
  _default.register('clearSubPageCache', spa.clearSubPageCache)
  _default.register('onClearSubPageCache', spa.onClearSubPageCache)

  // debug
  _default.register('performance.beginSession', performance.beginSession)
  _default.register('performance.endSession', performance.endSession)

  // iot 比较特殊，使用通配符
  _default.register('iot.*', function (params: unknown, config?: { deviceId?: string;[key: string]: unknown }) {
    const serviceName = this.property
    return (iot as any)?.[serviceName](params, config)
  })

  if (env.platform === 'android') {
    registerNativeAPI(_default)
  }

  if (env.platform === 'web') {
    globalThis.MaxAPI = webMaxAPI
  }
}

export function registerOfficialApi() {
  // 解析所有一方cloud，生成 max.lib.服务包.API 作用域
  const officialApi = JSON.parse(cache.get('_officialApi_') ?? null)
  officialApi?.map((i) => {
    const [pkg, api] = i.serviceName.split('.')
    _default.register(`lib.${pkg}.${api}`, (...arg) => net.serviceCall(i.serviceName, ...arg))
  })
}

export function register() {
  if (!inited) {
    registerRouter()
    registerBase()
    registerOfficialApi()
    inited = true
  }
}
